import Rollbar from 'rollbar';

import { isDevelopment } from 'bones/utils/environment';
import { isOnPremise } from 'bones/utils/portal/environment';

class RollbarAgent {
  loaded = false;

  rollbar: Rollbar | undefined;

  load() {
    const accessToken = process.env.ROLLBAR_ACCESS_TOKEN;
    if (!accessToken || isOnPremise()) {
      return;
    }

    if (!this.loaded) {
      this.rollbar = new Rollbar({
        accessToken,
        autoInstrument: {
          network: true,
          log: isDevelopment(),
          dom: false,
          navigation: true,
          connectivity: true,
        },
        captureIp: false,
        captureUncaught: true,
        captureUnhandledRejections: true,
        code_version: process.env.APP_VERSION,
        payload: {
          environment: process.env.NODE_ENV,
        },
      });

      this.loaded = true;

      this.rollbar.configure({ enabled: true });
    }
  }
}

export const rollbarAgent = new RollbarAgent();
